import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { formatNewsDate } from '../../../Model/News/newsArticle.js'
import { findNewsArticle } from '../../../Model/News/newsArticles.js'
import { NewsMarkdown } from './NewsMarkdown.js'

export const NewsArticlePage = () => {
  const { slug } = useParams<{ slug: string }>()
  const article = findNewsArticle(slug)
  const { hash } = useLocation()

  useEffect(() => {
    if (hash) {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView()
    }
  }, [hash, article])

  return (
    <div className="mx-auto w-full max-w-5xl p-4">
      <Link to="/news" className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900">
        <ArrowLeftIcon className="h-4 w-4" />
        All news
      </Link>
      {article ? (
        <article className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm md:p-10">
          <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-primary-600">{formatNewsDate(article.date)}</p>
          <div className="prose prose-slate max-w-none">
            <NewsMarkdown article={article} />
          </div>
        </article>
      ) : (
        <p className="text-slate-600">This news article does not exist.</p>
      )}
    </div>
  )
}
